import { DUPLICATE_INSERT, matchesAirror } from '@air/errors';
import { isError } from 'lodash';

export const getTagErrorMessage = (error: unknown, tagName: string) =>
  matchesAirror(error, DUPLICATE_INSERT)
    ? `Tag "${tagName}" is already used in your workspace`
    : isError(error)
    ? error.message
    : 'An error occurred - please try again later';
